import styled, { createGlobalStyle } from "styled-components";

export const Styles = styled.div`
  overflow: auto;
`;

export const GlobalScrollbarStyle = createGlobalStyle`
  body {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  body::-webkit-scrollbar {
    display: none;
  }
`;
